import React from 'react'
import { Component } from 'react'
import { Route, Navigate } from 'react-router-dom'
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants'
import authService from './AuthorizeService'

export default class AuthorizeRoute extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ready: false,
            authenticated: false,
            isAdmin: false
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.authenticationChanged());
        this.populateAuthenticationState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    render(props) {
        const { ready, authenticated, isAdmin } = this.state;
        const redirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURI(window.location.href)}`
        if (!ready) {
            return <div />;
        } else {
            const { component: Component, admin, ...rest } = this.props;
            if (authenticated) {
                if (admin && isAdmin) {
                    return <Component {...props} />
                }
                else if (admin && !isAdmin) {
                    return <Navigate to="/" />
                }
                return <Component {...props} />
            } else {
                return <Navigate to={redirectUrl} />
            }
        }
    }

    async populateAuthenticationState() {
        const authenticated = await authService.isAuthenticated();
        let isAdmin = false;

        if (authenticated) {
            const user = await authService.getUser();
            const role = user ? user.role : '';
            isAdmin = role === "Admin";
        }

        this.setState({ ready: true, authenticated, isAdmin });
    }

    async authenticationChanged() {
        this.setState({ ready: false, authenticated: false });
        await this.populateAuthenticationState();
    }
}

AuthorizeRoute.defaultProps = { admin: false, owner: false };
